module.exports = __webpack_public_path__ + "9b877abc28aa96af9c2566d681b34fe2.png";